<template>
    <span
        class="status is-transparent d-flex p-0"
        :class="[
            isSuccess || (value >= goal && value !== 0)
                ? 'text-success'
                : 'text-danger'
        ]"
    >
        <a-icon
            :icon="
                isSuccess || (value >= goal && value !== 0)
                    ? 'Success'
                    : 'Warning'
            "
        />
        <span
            >{{ value | number }}
            /
            {{ displayGoal | number }}
            <span v-if="showProgress">({{ progress }}%)</span></span
        >
    </span>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: true
        },
        goal: {
            type: Number,
            required: true
        },
        displayGoal: {
            type: Number,
            required: true
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        isSuccess: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        progress() {
            return isNaN(this.value / this.displayGoal)
                ? 0
                : ((this.value / this.displayGoal) * 100).toFixed(1)
        }
    }
}
</script>
